import { useTranslate } from "@refinedev/core";
import { Create } from "@refinedev/antd";
import {
    Drawer,
    DrawerProps,
    Form,
    FormProps,
    Input,
    ButtonProps,
    Typography,
    Grid,
    InputNumber,
    DatePicker,
} from "antd";
import locale from 'antd/es/date-picker/locale/sv_SE';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import { APP_WRITE_PROSPECT_ID } from "utility/constants";
import TextArea from "antd/es/input/TextArea";
import { CustomerSelectOptions } from "components/customerSelectOption";
import Select from "antd/lib/select";

type CreateProps = {
    drawerProps: DrawerProps;
    formProps: FormProps;
    saveButtonProps: ButtonProps;
};

export const CreateProspect: React.FC<CreateProps> = ({
    drawerProps,
    formProps,
    saveButtonProps
}) => {
    const t = useTranslate();
    const breakpoint = Grid.useBreakpoint();

    // const { customerSelectProps } = CustomerSelectOptions();
    

    return (
      <Drawer
        {...drawerProps}
        width={breakpoint.sm ? "500px" : "100%"}
        zIndex={1001}
      >
        <Create
          title={"Skapa nytt lead"}
          saveButtonProps={saveButtonProps}
          resource={APP_WRITE_PROSPECT_ID}
          goBack={false}
          contentProps={{
            style: {
              boxShadow: "none",
            },
            bodyStyle: {
              padding: 0,
            },
          }}
        >
          <Form {...formProps} layout="vertical" initialValues={{country: "Sverige"}}>
            <Form.Item
              label="Namn"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
                label="Omsättning (miljoner kr)"
                name="revenue"
                rules={[
                    {
                    required: true,
                    },
                ]}
                >
                <InputNumber min={0}  step="1"/>
            </Form.Item>
            <Form.Item label="Behov" name="needs">
              <TextArea rows={10}></TextArea>
            </Form.Item>
            <Form.Item
                label="Senaste kontakt"
                name="latestContact"
                >
                <DatePicker locale={locale}/>
            </Form.Item>
            <Form.Item label={"Nuvarande plattform"} name="currentPlattform">
              <Select
                placeholder={"Välj plattform"}
                style={{ width: "100%" }}
                options={[
                  {
                    label: "Norce",
                    value: "Norce",
                  },
                  {
                    label: "Centra",
                    value: "Centra",
                  },
                  {
                    label: "Quickbutik",
                    value: "Quickbutik",
                  },
                  {
                    label: "Nyehandel",
                    value: "Nyehandel",
                  },
                  {
                    label: "Wikinggruppen",
                    value: "Wikinggruppen",
                  },
                  {
                    label: "Shopify",
                    value: "Shopify",
                  },
                  {
                    label: "WooCommerce",
                    value: "WooCommerce",
                  },
                  {
                    label: "Wix",
                    value: "Wix",
                  },
                  {
                    label: "Abicart",
                    value: "Abicart",
                  },
                  {
                    label: "Magento",
                    value: "Magento",
                  },
                  {
                    label: "PrestaShop",
                    value: "PrestaShop",
                  },
                  {
                    label: "Askås",
                    value: "Askås",
                  },
                  {
                    label: "BigCommerce",
                    value: "BigCommerce",
                  },
                  {
                    label: "Weebly",
                    value: "Weebly",
                  },                  {
                    label: "3dcart",
                    value: "3dcart",
                  },                  {
                    label: "Ecwid",
                    value: "Ecwid",
                  },                  {
                    label: "Nordisk E-handel",
                    value: "Nordisk E-handel",
                  },                  {
                    label: "Annan",
                    value: "Annan",
                  }
                ]}
              />
            </Form.Item>
            <Form.Item label={"Land"} name="country">
              <Select
                placeholder={"Välj land"}
                style={{ width: "100%" }}
                options={[
                  {
                    label: "Sverige",
                    value: "Sverige",
                  },
                  {
                    label: "Danmark",
                    value: "Danmark",
                  },
                  {
                    label: "Finland",
                    value: "Finland",
                  },
                  {
                    label: "Norge",
                    value: "Norge",
                  },
                  {
                    label: "England",
                    value: "England",
                  },
                  {
                    label: "Tyskland",
                    value: "Tyskland",
                  }
                ]}
              />
            </Form.Item>
          </Form>
        </Create>
      </Drawer>
    );
};
